const VARIANT_CLASSES = {
  primary:
    "bg-(--brand-primary) text-(--brand-primary-contrast) hover:opacity-90",
  secondary:
    "bg-(--surface-2) text-(--text-primary) border border-(--border-subtle) hover:bg-(--surface-muted)",
  ghost: "bg-transparent text-(--text-primary) hover:bg-(--surface-2)",
  danger: "bg-(--status-danger) text-(--text-inverse) hover:opacity-90",
  success: "bg-(--status-success) text-(--text-inverse) hover:opacity-90",
};

const SIZE_CLASSES = {
  small: "px-3 py-1.5 text-sm",
  medium: "px-4 py-2 text-sm",
  large: "px-5 py-2.5 text-base",
};

export default function Button({
  children,
  onClick,
  variant = "primary",
  size = "medium",
  disabled = false,
  type = "button",
  className = "",
}) {
  const variantClass = VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.primary;
  const sizeClass = SIZE_CLASSES[size] ?? SIZE_CLASSES.medium;

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-(--radius-md) font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${variantClass} ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
